

<template>
  <div>
    <!-- Header Area Start -->
    <header class="header_area">
      <top-nav-menu/>
    </header>
    <!-- Header Area End -->
    <hero-area/>
  </div>
</template>
<script>

import HeroArea from "../../components/HeroArea";
import TopNavMenu from "../../components/menus/TopNavMenu";


export default {
  name: 'StarterHeader',
  components: {TopNavMenu, HeroArea}
}
</script>




// WEBPACK FOOTER //
// src/layout/starter/StarterHeader.vue